var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "chat_svg__ds",
    x1: 126.96,
    y1: 215.04,
    x2: 170.64,
    y2: 215.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chat_svg__dt",
    x1: 191.76,
    x2: 235.44,
    xlinkHref: "#chat_svg__ds"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chat_svg__du",
    x1: 253.68,
    x2: 297.36,
    xlinkHref: "#chat_svg__ds"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "chat_svg__az"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 110,
    width: 317,
    height: 209.4,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 116,
    width: 305,
    height: 197.4,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "chat_svg__dr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m280.36,110h-131c-51.48,0-93.36,41.88-93.36,93.36v104.04c0,6.62,5.38,12,12,12h212.36c51.08,0,92.64-41.56,92.64-92.64v-24.12c0-51.08-41.56-92.64-92.64-92.64Zm0,185.4H80v-92.04c0-38.25,31.12-69.36,69.36-69.36h131c37.85,0,68.64,30.79,68.64,68.64v24.12c0,37.85-30.79,68.64-68.64,68.64Z",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.8,
    cy: 215.04,
    r: 21.84,
    style: {
      fill: "url(#chat_svg__ds)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.6,193.2c-12.04,0-21.84,9.8-21.84,21.84s9.8,21.84,21.84,21.84,21.84-9.8,21.84-21.84-9.8-21.84-21.84-21.84Z",
    style: {
      fill: "url(#chat_svg__dt)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.52,193.2c-12.04,0-21.84,9.8-21.84,21.84s9.8,21.84,21.84,21.84,21.84-9.8,21.84-21.84-9.8-21.84-21.84-21.84Z",
    style: {
      fill: "url(#chat_svg__du)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.bf39cdb0119a3b42587ab03a680a3eb7.svg";
export { ForwardRef as ReactComponent };